import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface FileRowProps {
  onRequestRemove: (file: File) => void;
  file: File;
  additionalContent?: React.ReactNode;
  /**
   * If true, no trash can icon will be shown.
   */
  disabled?: boolean;
}

/**
 * UI element showing an uploaded/pending file. A trash can icon can be clicked to call onRequestRemove.
 *
 * Commonly used alongside FileChooser and FileList.
 */
export default function FileRow(props: FileRowProps): JSX.Element {
  return (
    <tr>
      <td className="u-lr-split">
        <span>
          <BenchlingIcon className="faded files-picker-icon" icon="file" /> {props.file.name}
        </span>
        <span className="u-vertical-center-items">
          {props.additionalContent}
          {!props.disabled && (
            <BenchlingIcon
              className="u-small-spacing-left u-danger-pointer faded"
              icon="trash-can"
              onClick={() => {
                props.onRequestRemove(props.file);
              }}
            />
          )}
        </span>
      </td>
    </tr>
  );
}
